// Single source of truth mapping a brand (window.env.VUE_APP_CONTEXT) to the
// applicative context. Returns the 'B2ag' | 'Retail' string union aligned with
// the `Context` enum from @invivodf/common, defined locally here to avoid a
// circular dependency from the auth package towards common.
const RETAIL_BRANDS = ['jardiland', 'gammvert']

export function getContextForBrand(brand: string | undefined | null): 'B2ag' | 'Retail' {
  return brand && RETAIL_BRANDS.includes(brand) ? 'Retail' : 'B2ag'
}
